import { Button } from '@music-vine/cadence/ui';
import Image from 'next/image';
const MediaKit = () => <section className="special-page-container relative z-[1] py-5 md:py-10" data-sentry-component="MediaKit" data-sentry-source-file="MediaKit.tsx">
    <div className="flex flex-col-reverse gap-8 md:flex-row md:items-center">
      <div className="w-full shrink-0 md:max-w-90">
        <p className="mb-1 font-sans font-semibold text-pink-600 text-sm dark:text-pink-400">
          MEDIA KIT
        </p>
        <h2 className="mb-3 text-pretty font-semibold text-2xl 2xl:text-3xl">
          Everything you need to promote Uppbeat
        </h2>
        <p className="text-pretty font-sans text-base text-gray-700 dark:text-gray-200">
          Grab logos, screenshots, and ready-to-post clips and more from the
          media kit.
        </p>
        <Button asChild className="mt-8 max-sm:w-full" size="lg" variant="bold" data-sentry-element="Button" data-sentry-source-file="MediaKit.tsx">
          <a download href="/downloads/uppbeat-media-kit.pdf">
            Download media kit
          </a>
        </Button>
      </div>
      <div className="w-full md:flex-1">
        <Image alt="Preview of pages from the Uppbeat media kit, including logos and ready-to-post social graphics" className="h-auto w-full rounded-lg" height={729} src="https://cdn.uppbeat.io/images/refer-and-earn-media-kit.webp" unoptimized width={1440} data-sentry-element="Image" data-sentry-source-file="MediaKit.tsx" />
      </div>
    </div>
  </section>;
export default MediaKit;